import React from 'react';
import { Route } from 'react-router';
import RootRoute from './root';
import AppRoute from './app';
import * as Auth from './auth';
import * as Projects from './projects';
import * as Project from './project';
import * as Account from './account';
import * as Submissions from './submissions';

const routes = (
  <Route component={RootRoute}>    
    <Route
      path="/login"
      component={Auth.LoginRoute}
    />
    <Route
      path="/signup"
      component={Auth.SignUpRoute}
     />
    <Route
      path="/recover"
      component={Auth.RecoverRoute}
    />
    <Route
      path="/reset-password"
      component={Auth.ResetPasswordRoute}
    />

    <Route component={AppRoute}>
      <Route
        path="/project/create"
        component={Projects.CreateRoute}
      />
      <Route
        path="/project/create/onboarding"
        component={Projects.OnboardingRoute}
      />
      <Route component={Project.LayoutRoute}>
        <Route
          path="/"
          component={Projects.OnboardingRoute}
        />
        <Route
          path="/project"
          component={Projects.OnboardingRoute}
        />
        <Route
          path="/project/:id"
          component={Project.ShowRoute}
        />
        <Route
          path="/project/:id/submissions"
          component={Submissions.ListRoute}
        />
        <Route
          path="/project/:id/submissions/:submissionId"
          component={Submissions.ShowRoute}
        />
        <Route
          path="/project/:id/insights"
          component={Project.InsightsRoute}
        />
        <Route
          path="/project/:id/insights/:taskFormId"
          component={Project.InsightsRoute}
        />
        <Route
          path="/project/:id/edit"
          component={Projects.CreateRoute}
        />
      </Route>

      <Route
        path="/gallery"
        component={Projects.GalleryRoute}
      />

      <Route
        path="/gallery/:id"
        component={Projects.GalleryRoute}
      />

      <Route
        path="/heat-map"
        component={Projects.HeatMapRoute}
      />

      <Route component={Account.LayoutRoute}>
        <Route
          path="/account/edit"
          component={Account.EditRoute}
        />
        <Route
          path="/account/reports"
          component={Account.ReportsRoute}
        />
      </Route>
    </Route>
  </Route>
)

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js